import request from "@/axios.js";

export default class Product {
	/**
	 * Product class
	 * @property {number} category - a category.
	 * @property {number} sub_category - a sub_category.
	 * @property {number} perform - a perform.
	 * @property {string} shortDescription - an short Description of the product.
	 * @property {string} longDescription - a long Description of the product.
	 * @property {boolean} isNetlink - if netlink 1 if not 0.
	 * @property {number} deliverable - Product for "Prestation"(service)?
	 * @property {number} missionable - Product for "Commande"(order)?
	 */
	constructor(product) {
		this.id = product.id;
		this.category = product.category;
		this.sub_category = product.sub_category;
		this.perform = product.perform;
		this.shortDescription = product.short_description;
		this.longDescription = product.long_description;
		this.isNetlink = product.is_netlink;
		this.deliverable = product.deliverable;
		this.missionable = product.missionable;
		this.currency = product.currency;
		this.flexible = product.flexible;
	}

	/**
	 * Create an object to be used for forms (on creation)
	 * @return {object} product object
	 */
	static getFormFields(){
		return {
			category: 0,
			sub_category: 0,
			perform: null,
			shortDescription: null,
			longDescription: null,
			isNetlink: 0, // Not a netlink by default
			deliverable: 0,
			missionable: 0,
			currency: null,
			flexible: 0,
		};
	}

	/**
	 * Fetch all possible categories for a product
	 * @return {object[]} - Array of categories
	 */
	static getProductCategories() {
		return [
			{text: "SEO", value: 0},
			{text: "SEA", value: 1},
			{text: "E-Réputation", value: 2},
			{text: "Social ads", value: 3},
			{text: "RP Digitale", value: 4},
			{text: "Formation", value: 5},
			{text: "Autre", value: 6},
			{text: "Content", value: 7},
		];
	}

	static getAllProducts(callback){
		request.get("/product/all")
			.then(res => {
				callback(null, res);
			})
			.catch(err => {
				callback(err, null);
			});
	}

	delete(callback){
		request.delete("/product/delete/" + this.id)
			.then(res => {
				callback(null, res);
			})
			.catch(err => {
				callback(err, null);
			});
	}

	static getCurrencies(){
		return new Promise((resolve, reject) => {
			request.get("/product/currencies/all")
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
}
